export default __webpack_public_path__ + "static/media/my-contact-profile.54a7feb7.svg";